import { useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthUser } from 'react-auth-kit';
import useNotificationChatCount from '../../store/useNotificationCount';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import SocketContext from '../../contexts/SocketContext';
import { useGetUnreadMessage } from '../../hooks/query/chat';
// import { SocketContext } from '../../context/SocketContext';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 80;

const RootStyle = styled('div')({
	display: 'flex',
	minHeight: '100%',
	overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
	flexGrow: 1,
	overflow: 'auto',
	minHeight: '100%',
	paddingTop: APP_BAR_MOBILE + 24,
	paddingBottom: theme.spacing(10),
	[theme.breakpoints.up('lg')]: {
		paddingTop: APP_BAR_DESKTOP,
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
	},
}));

export default function DashboardLayout() {
	const queryClient = useQueryClient();

	const { socket } = useContext(SocketContext);

	const [open, setOpen] = useState(false);

	const auth = useAuthUser();

	const { setNotificationCount } = useNotificationChatCount((state) => ({
		setNotificationCount: state.setNotificationCount,
	}));

	const { data, isInitialLoading } = useGetUnreadMessage(auth()?._id, {});

	// connect socket
	useEffect(() => {
		socket?.on('connect', () => {
			console.log('Connected to server');
		});

		socket?.emit('addUser', auth()?._id);

		return () => {
			socket?.off('connect');
			socket?.off('addUser');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [socket]);

	useEffect(() => {
		socket?.on('getNotification', (data) => {
			if (data) {
				queryClient.invalidateQueries(['chat_notification']);
				queryClient.invalidateQueries(['conversation']);
			}
		});

		return () => {
			socket?.off();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [socket]);

	useEffect(() => {
		if (!isInitialLoading) {
			setNotificationCount(data?.length);
		}
	}, [data, isInitialLoading, setNotificationCount]);

	console.log('render index dashboard');

	return (
		<RootStyle>
			<DashboardNavbar onOpenSidebar={() => setOpen(true)} />

			<DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

			<MainStyle>
				<Outlet />
			</MainStyle>
		</RootStyle>
	);
}
